import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { httpOptions } from '@portal-workspace/grow-ui-library';
import {
  DYNABOT_FEATURE_FLAG,
  DynabotChatRequest,
  DynabotChatResponse,
  DynabotKnowledgeFile,
  GetDynabotKnowledgeFilesFn,
  PayloadApiResponse,
  SaveDynabotKnowledgeFileFn,
  SaveDynabotKnowledgeFileRequest,
  SendDynabotMessageFn,
} from '@portal-workspace/grow-shared-library';
import { environment } from '../../environments/environment';

const URL_DYNABOT_CHAT = () => `${environment.api2Host}/api2/dynabot-chat`;
const URL_CHECK_DYNABOT_ACCESS = () => `${environment.api2Host}/api2/admin/feature-flags/${DYNABOT_FEATURE_FLAG}/check-access`;
const URL_GET_DYNABOT_KNOWLEDGE_FILES = () => `${environment.api2Host}/api2/admin/dynabot/get-knowledge-files`;
const URL_SAVE_DYNABOT_KNOWLEDGE_FILE = () => `${environment.api2Host}/api2/admin/dynabot/save-knowledge-file`;

@Injectable()
export class DynabotService {

  constructor(private httpClient: HttpClient) {}

  /** Background check with no user action behind it, so failures quietly hide the widget. */
  isDynabotEnabled(): Observable<boolean> {
    return this.httpClient.get<PayloadApiResponse<boolean>>(URL_CHECK_DYNABOT_ACCESS(), httpOptions()).pipe(
      map(response => !!response.status && !!response.payload),
      catchError(() => of(false)),
    );
  }

  sendDynabotMessageFn: SendDynabotMessageFn = (request: DynabotChatRequest) =>
    this.httpClient.post<PayloadApiResponse<DynabotChatResponse | null>>(URL_DYNABOT_CHAT(), request, httpOptions());

  getDynabotKnowledgeFilesFn: GetDynabotKnowledgeFilesFn = () =>
    this.httpClient.get<PayloadApiResponse<DynabotKnowledgeFile[]>>(URL_GET_DYNABOT_KNOWLEDGE_FILES(), httpOptions());

  saveDynabotKnowledgeFileFn: SaveDynabotKnowledgeFileFn = (request: SaveDynabotKnowledgeFileRequest) =>
    this.httpClient.post<PayloadApiResponse<DynabotKnowledgeFile>>(URL_SAVE_DYNABOT_KNOWLEDGE_FILE(), request, httpOptions());
}
